const AUTO_CLOSE_MS = 3200;

function createAlertElements() {
  const overlay = document.createElement("div");
  overlay.className = "custom-alert-overlay";
  overlay.setAttribute("aria-live", "polite");

  const popup = document.createElement("div");
  popup.className = "custom-alert-popup";
  popup.setAttribute("role", "alertdialog");
  popup.setAttribute("aria-modal", "false");

  const message = document.createElement("p");
  message.className = "custom-alert-message";

  const closeButton = document.createElement("button");
  closeButton.className = "custom-alert-close";
  closeButton.type = "button";
  closeButton.setAttribute("aria-label", "Close notification");
  closeButton.textContent = "OK";

  popup.appendChild(message);
  popup.appendChild(closeButton);
  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  return { overlay, message, closeButton };
}

export function installCustomAlert() {
  if (typeof window === "undefined") {
    return;
  }

  if (window.__chatappCustomAlertInstalled) {
    return;
  }

  const { overlay, message, closeButton } = createAlertElements();
  let hideTimer = null;

  const closePopup = () => {
    overlay.classList.remove("custom-alert-visible");
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  };

  const showPopup = (text) => {
    message.textContent = String(text || "");
    overlay.classList.add("custom-alert-visible");

    if (hideTimer) {
      clearTimeout(hideTimer);
    }

    hideTimer = setTimeout(closePopup, AUTO_CLOSE_MS);
  };

  closeButton.addEventListener("click", closePopup);
  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) {
      closePopup();
    }
  });

  window.alert = showPopup;
  window.__chatappCustomAlertInstalled = true;
}
